import {useTranslation} from 'react-i18next';
import {DisplayableShareLandTransaction, modifyDate} from 'shareland-common';
import {useBlock} from 'wagmi';

export const useTransactionDate = (transaction: DisplayableShareLandTransaction): Date | null => {
  const {data: block} = useBlock({
    blockNumber: BigInt(transaction.blockNumber),
  });

  return !!block ? new Date(Number(block.timestamp) * 1000) : null;
};

export const useFormattedDistanceDate = (
  date: Date | null,
): {
  distance?: string;
  date?: string;
} => {
  const {t} = useTranslation('translation');

  if (date === null) return {};

  const now = new Date();

  if (modifyDate(now, {minutes: -30}) < date) {
    return {
      distance: t('utils.dateDistance', {
        date,
      }),
    };
  }

  return {
    date: t('utils.date', {
      date,
    }),
  };
};
